import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren, signal, computed, effect, ChangeDetectorRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { MenubarModule } from 'primeng/menubar';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { HomeProfileComponent } from '../profile/profile.component';
import { GetVerifiedPopupComponent } from 'src/app/shared/components/get-verified-popup/get-verified-popup.component';
import { MenuPopoverComponent } from '../menu-popover/menu-popover.component';
import { IUser } from 'src/app/interface/user.interface';
import { AuthService } from 'src/app/shared/services/auth.service';
import { filter } from 'rxjs/operators';
import { AddRequestPopupComponent } from 'src/app/shared/components/add-request-popup/add-request-popup.component';
import { UiStateService } from 'src/app/shared/services/chat-signal.service';
import { MobileActivityService } from 'src/app/shared/services/mobile-activity.service';
import { PwaService } from 'src/app/shared/services/pwa.service';
import { InitialsPipe } from 'src/app/shared/pipe/initials.pipe';
import { Subject, debounceTime, distinctUntilChanged, switchMap, of, takeUntil } from 'rxjs';
import { GlobalSearchService, GlobalSearchResult } from 'src/app/shared/services/global-search.service';
import { UserTypeIdEnum } from 'src/app/shared/interfaces/user.interface';
import { SuperAdminAccessService } from 'src/app/shared/services/super-admin-access.service';
import { ImpersonationService } from 'src/app/shared/services/impersonation.service';
import { ViewportService } from 'src/app/shared/services/viewport.service';
import { UnreadActivityService } from 'src/app/shared/services/unread-activity.service';
import { UnreadCountsService } from 'src/app/shared/services/unread-counts.service';
import { ChatViewService } from 'src/app/shared/services/chat-view.service';


import { isDetailPageUrl } from 'src/app/shared/utils/detail-page.util';
@Component({
  selector: 'pa-header',
  imports: [
    CommonModule,
    RouterModule,
    MenubarModule,
    ButtonModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    AvatarModule,
    BadgeModule,
    MenuModule,
    HomeProfileComponent,
    MenuPopoverComponent,
    AddRequestPopupComponent,
    InitialsPipe,
    GetVerifiedPopupComponent,
  ],
  providers: [],
  templateUrl: './header.component.html',
  styles: [`
    :host {
      display: block;
    }

    ::ng-deep {
      .p-button-text.p-button-plain {
        color: #6b7280;
      }
      
      .p-button-text.p-button-plain:hover {
        color: #2563eb;
        background-color: #f3f4f6;
      }

      .p-avatar {
        width: 2.5rem;
        height: 2.5rem;
      }

      .p-inputtext {
        border-radius: 0.5rem;
      }

      .p-inputtext {
        border:none !important;
        background-color: #F2F6F8 !important;
        cursor: text !important;
      }

      .p-inputtext:enabled:focus {
        outline: 0 none;
        outline-offset: 0;
        border:none;
        box-shadow: none;
      }

      .profile-dropdown-menu {
        margin-top: 4px !important;
        max-height: calc(100vh - 70px) !important;
        overflow-y: auto !important;
      }

      .p-menu.profile-dropdown-menu {
        /* PrimeNG renders popup menus with position:absolute (document-relative),
           so a fixed top offset drifts with page scroll. Force fixed positioning
           so it stays pinned under the header regardless of scroll, without
           needing to lock background scrolling. */
        position: fixed !important;
        z-index: 1000 !important;
        top: 55px !important;
       border-radius: 10px !important;
    box-shadow: none !important;
      }

      .profile-dropdown-menu::-webkit-scrollbar {
        width: 6px;
      }

      .profile-dropdown-menu::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
      }

      .profile-dropdown-menu::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 3px;
      }

      .profile-dropdown-menu::-webkit-scrollbar-thumb:hover {
        background: #555;
      }

        // .profile-dropdown-menu {
        //   width: min(345px, calc(100vw - 32px)) !important;
        // }
    }

    header {
      transition: box-shadow 0.3s ease;
    }

    /* iPad specific alignment */
    @media (min-width: 768px) and (max-width: 1366px) {
      nav {
        align-items: flex-end;
      }
    }

    /* Smooth transitions for search expand/collapse */
    .flex-1 {
      transition: all 0.3s ease-in-out;
    }

    ::ng-deep .p-iconfield {
      transition: width 0.3s ease-in-out;
    }

    .search-dropdown-container {
      @media (min-width: 690px) and (max-width: 1023px) {
        width: 635px !important;
        min-width: 635px !important;
      }
    }
  `]
})
export class HeaderComponent implements OnInit {
  /* ================= VIEW CHILDS ================= */
  @ViewChild('profileMenu') profileMenu!: Menu;
  @ViewChild('navContainer') navContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('profileButton') profileButton!: ElementRef<HTMLButtonElement>;
  @ViewChildren('bottomNavItem') bottomNavItems?: QueryList<ElementRef<HTMLAnchorElement>>;

  /* ================= SCREEN FLAGS ================= */
  readonly isDesktop = computed(() => this.viewport.width() >= 1025);
  readonly isTablet = computed(() => this.viewport.width() >= 690 && this.viewport.width() <= 1024);
  readonly isMobile = computed(() => this.viewport.width() < 690);
  readonly showBottomNav = computed(() => this.isMobile() || this.isTablet());
  isSearchActive = signal(false);
  showMobileProfilePanel = signal(false);
  showVerificationPopup = signal(false);
  verificationTargetUser = signal<IUser | null>(null);
  readonly isImpersonating = signal(false);

  // Computed property to check if navbar should be hidden
  shouldHideNavbar = computed(() => {
    return this.isMobile() && this.mobileActivity.showLatestActivities();
  });

  /* ================= DATA ================= */
  currentUser: IUser | null = null;
  isMoreMenuActive: boolean = false;
  isAddReqPopupVisible: boolean = false;
  isHomeScreen: boolean = false;
  isDetailPage: boolean = false;
  showOnlySwitchAccount: boolean = false;
  searchQuery: string = '';
  searchResults: GlobalSearchResult[] = [];
  isSearching: boolean = false;
  showSearchDropdown: boolean = false;
  searchLimit: number = 10;
  hasMoreResults: boolean = false;
  isLoadingMore: boolean = false;
  imageErrors: Record<string, boolean> = {};
  showAllResultsInDropdown = signal(false);
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  private searchSubject = new Subject<string>();
readonly mobilePanelCollabOffset = signal(0);

  private destroy$ = new Subject<void>();


  /* ================= PROFILE MENU ================= */

  /* ================= NAV ITEMS ================= */
  private readonly defaultMenuItems = [
    { label: 'Home', icon: 'assets/icons/home.png', activeIcon: 'assets/icons/home-active.png', routerLink: ['/home'] },
    { label: 'Assistant', icon: 'assets/icons/primebot.svg', activeIcon: 'assets/icons/prime-bot-active.svg', routerLink: ['/collab-rooms'] },
    { label: 'Calendar', icon: 'assets/icons/calendar.png', activeIcon: 'assets/icons/calendar-active.png', routerLink: ['/calendar'] },
    { label: 'Contacts', icon: 'assets/icons/contacts.png', activeIcon: 'assets/icons/contacts-active.png', routerLink: ['/contacts'] },
    { label: 'Messages', icon: 'assets/icons/messages.png', activeIcon: 'assets/icons/messages-active.png', routerLink: ['/messages'] },
    { label: 'Chat Rooms', icon: 'assets/icons/chat-rooms.png', activeIcon: 'assets/icons/chat-rooms-active.png', routerLink: ['/chat-rooms'] },
    { label: 'Prime', icon: 'assets/icons/prime.png', activeIcon: 'assets/icons/prime-active.png', routerLink: ['/prime'], extraActiveRoutes: ['/prime', '/prime-user'] },
    { label: 'Collabs', icon: 'assets/icons/collabs.png', activeIcon: 'assets/icons/collabs-active.png', routerLink: ['/collab'] },
    { label: 'Listings', icon: 'assets/icons/listing.png', activeIcon: 'assets/icons/listing-active.png', routerLink: ['/listings'] },
    { label: 'Meetups', icon: 'assets/icons/meetups.png', activeIcon: 'assets/icons/meetups-active.png', routerLink: ['/meetups'], extraActiveRoutes: ['/meetups', '/meetup-user'] },
    { label: 'Meetup Group', icon: 'assets/icons/meetups.png', activeIcon: 'assets/icons/meetups-active.png', routerLink: ['/meetup-groups'] },
    { label: 'Fundraise', icon: 'assets/icons/fundraise.png', activeIcon: 'assets/icons/fundraise-active.png', routerLink: ['/fundraise'] },
    { label: 'Requests', icon: 'assets/icons/requests.png', activeIcon: 'assets/icons/requests-active.png', routerLink: ['/requests'], extraActiveRoutes: ['/requests', '/frontdesk-requests', '/guests-entry', '/amenities'] },
    { label: 'To-Do tasks', icon: 'assets/icons/to-do-inactive.png', activeIcon: 'assets/icons/todo-active.svg', routerLink: ['/todo'] },
    { label: 'Reminders', icon: 'assets/icons/reminder.png', activeIcon: 'assets/icons/reminder-active.png', routerLink: ['/reminders'] },
    { label: 'Bookings', icon: 'assets/icons/bookings.png', activeIcon: 'assets/icons/bookings-active.png', routerLink: ['/bookings'] },
    { label: 'Transactions', icon: 'assets/icons/transaction.png', activeIcon: 'assets/icons/transaction-active.png', routerLink: ['/transactions'] },
    { label: 'Pay Rent', icon: 'assets/icons/payrent.png', activeIcon: 'assets/icons/payrent-active.png', routerLink: ['/pay-rent'] },
    { label: 'Services', icon: 'assets/icons/service.png', activeIcon: 'assets/icons/service-active.png', routerLink: ['/services'] },
    { label: 'File Center' ,icon: 'assets/icons/file-center-inactive.svg', activeIcon:'assets/icons/file-center.svg',routerLink:['/file-center'] },
  ];

  // Super admin + "Account Access" tab selected.
  private readonly superAdminAccountMenuItems: typeof this.defaultMenuItems = [
    { label: 'Home', icon: 'assets/icons/home.png', activeIcon: 'assets/icons/home-active.png', routerLink: ['/home'] },
    { label: 'Assistant', icon: 'assets/icons/primebot.svg', activeIcon: 'assets/icons/prime-bot-active.svg', routerLink: ['/collab-rooms'] },
    { label: 'Calendar', icon: 'assets/icons/calendar.png', activeIcon: 'assets/icons/calendar-active.png', routerLink: ['/calendar'] },
    { label: 'Contacts', icon: 'assets/icons/contacts.png', activeIcon: 'assets/icons/contacts-active.png', routerLink: ['/contacts'] },
    { label: 'Messages', icon: 'assets/icons/messages.png', activeIcon: 'assets/icons/messages-active.png', routerLink: ['/messages'] },
    { label: 'Chat Rooms', icon: 'assets/icons/chat-rooms.png', activeIcon: 'assets/icons/chat-rooms-active.png', routerLink: ['/chat-rooms'] },
    { label: 'Prime', icon: 'assets/icons/prime.png', activeIcon: 'assets/icons/prime-active.png', routerLink: ['/prime'], extraActiveRoutes: ['/prime', '/prime-user'] },
    { label: 'Collabs', icon: 'assets/icons/collabs.png', activeIcon: 'assets/icons/collabs-active.png', routerLink: ['/collab'] },
    { label: 'Listings', icon: 'assets/icons/listing.png', activeIcon: 'assets/icons/listing-active.png', routerLink: ['/listings'] },
    { label: 'Meetups', icon: 'assets/icons/meetups.png', activeIcon: 'assets/icons/meetups-active.png', routerLink: ['/meetups'], extraActiveRoutes: ['/meetups', '/meetup-user'] },
    { label: 'Meetup Group', icon: 'assets/icons/meetups.png', activeIcon: 'assets/icons/meetups-active.png', routerLink: ['/meetup-groups'] },
    { label: 'Fundraise', icon: 'assets/icons/fundraise.png', activeIcon: 'assets/icons/fundraise-active.png', routerLink: ['/fundraise'] },
    { label: 'Requests', icon: 'assets/icons/requests.png', activeIcon: 'assets/icons/requests-active.png', routerLink: ['/requests'], extraActiveRoutes: ['/requests', '/frontdesk-requests', '/guests-entry', '/amenities'] },
    { label: 'To-Do tasks', icon: 'assets/icons/to-do-inactive.png', activeIcon: 'assets/icons/todo-active.svg', routerLink: ['/todo'] },
    { label: 'Reminders', icon: 'assets/icons/reminder.png', activeIcon: 'assets/icons/reminder-active.png', routerLink: ['/reminders'] },
    { label: 'Bookings', icon: 'assets/icons/bookings.png', activeIcon: 'assets/icons/bookings-active.png', routerLink: ['/bookings'] },
    { label: 'Transactions', icon: 'assets/icons/transaction.png', activeIcon: 'assets/icons/transaction-active.png', routerLink: ['/transactions'] },
    { label: 'Pay Rent', icon: 'assets/icons/payrent.png', activeIcon: 'assets/icons/payrent-active.png', routerLink: ['/pay-rent'] },
    { label: 'Services', icon: 'assets/icons/service.png', activeIcon: 'assets/icons/service-active.png', routerLink: ['/services'] },
    { label: 'File Center' ,icon: 'assets/icons/file-center-inactive.svg', activeIcon:'assets/icons/file-center.svg',routerLink:['/file-center'] },
  
  ];

  // Super admin + "Admin Access" tab selected — Team/Disputes don't have real
  // pages yet, so those items intentionally don't navigate. Home renders the
  // Admin Dashboard at /home (see home.component.html).
  private readonly superAdminAdminMenuItems: typeof this.defaultMenuItems = [
    { label: 'Home', icon: 'assets/icons/home.png', activeIcon: 'assets/icons/home-active.png', routerLink: ['/home'] },
    { label: 'Admin Actions', icon: 'assets/icons/requests.png', activeIcon: 'assets/icons/requests-active.png', routerLink: ['/audit-log'] },
    { label: 'Calendar', icon: 'assets/icons/calendar.png', activeIcon: 'assets/icons/calendar-active.png', routerLink: ['/calendar'] },
    { label: 'Contacts', icon: 'assets/icons/contacts.png', activeIcon: 'assets/icons/contacts-active.png', routerLink: ['/contacts'] },
    { label: 'Team', icon: 'assets/icons/contacts.png', activeIcon: 'assets/icons/contacts-active.png', routerLink: ['/team'] as string[] },
    { label: 'Disputes', icon: 'assets/icons/requests.png', activeIcon: 'assets/icons/requests-active.png', routerLink: ['/disputes'] },
    { label: 'Messages', icon: 'assets/icons/messages.png', activeIcon: 'assets/icons/messages-active.png', routerLink: ['/messages'] },
    { label: 'Chat Rooms', icon: 'assets/icons/chat-rooms.png', activeIcon: 'assets/icons/chat-rooms-active.png', routerLink: ['/chat-rooms'] },
    { label: 'Collabs', icon: 'assets/icons/collabs.png', activeIcon: 'assets/icons/collabs-active.png', routerLink: ['/collab'] },
    { label: 'Listings', icon: 'assets/icons/listing.png', activeIcon: 'assets/icons/listing-active.png', routerLink: ['/listings'] },
    { label: 'Meetups', icon: 'assets/icons/meetups.png', activeIcon: 'assets/icons/meetups-active.png', routerLink: ['/meetups'], extraActiveRoutes: ['/meetups', '/meetup-user'] },
    { label: 'Meetup Group', icon: 'assets/icons/meetups.png', activeIcon: 'assets/icons/meetups-active.png', routerLink: ['/meetup-groups'] },
    { label: 'To-Do tasks', icon: 'assets/icons/to-do-inactive.png', activeIcon: 'assets/icons/todo-active.svg', routerLink: ['/todo'] },
    { label: 'Reminders', icon: 'assets/icons/reminder.png', activeIcon: 'assets/icons/reminder-active.png', routerLink: ['/reminders'] },
    { label: 'File Center' ,icon: 'assets/icons/file-center-inactive.svg', activeIcon:'assets/icons/file-center.svg',routerLink:['/file-center'] },
    
  ];

  get isSuperAdmin(): boolean {
    return String(this.currentUser?.user_type) === UserTypeIdEnum.ADMIN;
  }

  isProfilePictureBlocked(): boolean {
    const status = this.currentUser?.profile_picture_moderation_status;
    return status === 'flagged' || status === 'blocked';
  }

  get menuItems(): typeof this.defaultMenuItems {
    if (!this.isSuperAdmin) return this.defaultMenuItems;
    const items = this.superAdminAccessService.selectedTab() === 'admin'
      ? this.superAdminAdminMenuItems
      : this.superAdminAccountMenuItems;
    return this.showBottomNav() ? [...items.slice(0, 1), this.superAdminDashboardItem, ...items.slice(1)] : items;
  }

  private readonly superAdminDashboardItem: (typeof this.defaultMenuItems)[number] = {
    label: 'Dashboard', icon: 'assets/icons/super-dashboard-inactive.svg', activeIcon: 'assets/icons/super-dashboard.svg', routerLink: ['/home'],
  };

  hasUnreadFor(label: string): boolean {
    return label === 'Messages' ? this.unreadCounts.messages() > 0 : label === 'Chat Rooms' && this.unreadCounts.chatRooms() > 0;
  }

  // Messages / Chat Rooms can overflow into More; surface their unread dot on the More button
  hasUnreadInMore(): boolean {
    return this.moreMenuItemsData.some(item => this.hasUnreadFor(item.label));
  }

  visibleMenuItems: typeof this.defaultMenuItems = [];
  moreMenuItems: MenuItem[] = [];
  moreMenuItemsData: typeof this.defaultMenuItems = [];

  public readonly unreadActivity = inject(UnreadActivityService);
  private readonly unreadCounts = inject(UnreadCountsService);
  private readonly chatViewService = inject(ChatViewService);

  constructor(
    private auth: AuthService,
    private router: Router,
    public uiState: UiStateService,
    public mobileActivity: MobileActivityService,
    public pwaService: PwaService,
    private globalSearchService: GlobalSearchService,
    private cdr:ChangeDetectorRef,
    private superAdminAccessService: SuperAdminAccessService,
    private impersonationService: ImpersonationService,
    private viewport: ViewportService
  ) {
    effect(() => {
      this.superAdminAccessService.selectedTab();
      this.updateVisibleItems();
    });

    effect(() => {
      this.isDesktop();
      setTimeout(() => this.updateVisibleItems());
    });
  }

  onLogoClick(event: Event): void {
    if (this.pwaService.isStandalone()) {
      event.preventDefault();
      this.pwaService.refreshApp();
    }
  }

  ngOnInit(): void {
    this.currentUser = this.auth.getUser();
    this.isImpersonating.set(this.impersonationService.isImpersonating());
    this.auth.getUserData()
      .pipe(takeUntil(this.destroy$))
      .subscribe((userData: unknown) => {
        if (this.isUserPayload(userData)) {
          this.currentUser = userData;
        }
      });

    this.updateProfileMenu();
    this.setupSearch();


    // IMPORTANT: wait for view to render
    setTimeout(() => this.updateVisibleItems());
    setTimeout(() => this.scrollActiveBottomNavIntoView());

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkMoreMenuActive();
        this.updateProfileMenu();
        this.showOnlySwitchAccount = false;
        this.showMobileProfilePanel.set(false);
        setTimeout(() => this.scrollActiveBottomNavIntoView());
      });
  }

  private isUserPayload(value: unknown): value is IUser {
  return !!value && typeof value === 'object' && 'user_id' in value;
}
onCollabRailOffset(offset: number): void {
  this.mobilePanelCollabOffset.set(offset);
  this.cdr.markForCheck();
}

mobileProfilePanelHeight(): string {
  const maxAvailable = window.innerHeight - 136;
  return `${Math.min(650, maxAvailable)}px`;
}
  private updateProfileMenu(): void {
    const url = this.router.url.split('?')[0].split('#')[0];
    this.isHomeScreen = url === '/home';
    this.isDetailPage = isDetailPageUrl(url);
  }


  toggleSearch() {
    this.isSearchActive.set(!this.isSearchActive());
    if (this.isSearchActive()) {
      setTimeout(() => {
        const input = document.querySelector('input[pInputText]') as HTMLInputElement;
        if (input) input.focus();
      }, 300);
    }
    setTimeout(() => this.updateVisibleItems());
  }

  closeSearch() {
    this.isSearchActive.set(false);
    this.clearSearch();
    if (this.isMobile() && this.router.url.startsWith('/global-search')) {
      this.router.navigate(['/home']);
    }
    setTimeout(() => this.updateVisibleItems());
  }

  /* ================= 🔥 FIXED NAV LOGIC ================= */
  private updateVisibleItems(): void {
    if (!this.navContainer) return;

    const containerWidth = this.navContainer.nativeElement.offsetWidth;

    const ITEM_WIDTH = 80; // safe average
    const maxItems = Math.max(
      0,
      Math.floor(containerWidth / ITEM_WIDTH) - 1
    );

    this.visibleMenuItems = this.menuItems.slice(0, maxItems);

    const overflowItems = this.menuItems.slice(maxItems);
    this.moreMenuItemsData = overflowItems;

    this.moreMenuItems = overflowItems.map((item, index) => ({
      label: item.label,
      routerLink: item.routerLink,
      icon: item.activeIcon,
      data: {
        icon: item.activeIcon,
        activeIcon: item.activeIcon,
        extraActiveRoutes: item.extraActiveRoutes,
        index
      }
    }));

    this.checkMoreMenuActive();
  }

  toggleProfileMenu(event: Event) {
    event.preventDefault();
    if (!this.isDesktop()) {
      this.showMobileProfilePanel.update(v => !v);
      return;
    }
    this.profileMenu.toggle(event);
  }

  closeMobileProfilePanel(): void {
    this.showMobileProfilePanel.set(false);
    if (this.profileMenu) {
    this.profileMenu.hide();
  }
  }

  onGetVerified() {
    console.log('Get verified clicked');
    // Implement verification logic
  }

  onViewProfile() {
    if (this.currentUser?.user_id) {
      this.router.navigate(['/contacts', this.currentUser.user_id]);
    }
  }

  onLogout() {
    this.auth.logout();
  }

  private normalizeUrl(url: string): string {
    return url.split('?')[0].split('#')[0];
  }

  isItemActive(item: any, rlaIsActive: boolean): boolean {
    if (this.isSuperAdmin && this.showBottomNav() && (item?.label === 'Dashboard' || item?.label === 'Home')) {
      const tab = item.label === 'Dashboard' ? 'admin' : 'account';
      return this.normalizeUrl(this.router.url) === '/home' && this.superAdminAccessService.selectedTab() === tab;
    }
    if (!item?.extraActiveRoutes) return rlaIsActive;
    const url = this.normalizeUrl(this.router.url);
    return item.extraActiveRoutes.some((route: string) => url === route || url.startsWith(route + '/'));
  }

  /** routerLink no-ops when re-clicking the already-active route, so a tablet user with a
   * chat room open who taps "Chat Rooms" again would otherwise see nothing happen. Detect
   * that specific re-click and tell ChatRoomsComponent to collapse back to the room list. */
  onNavItemClick(item: any): void {
    this.mobileActivity.closeLatestActivities();
    this.mobileActivity.closeHappeningNow();
    this.mobileActivity.showLeaderboard.set(false);
    if (this.isSuperAdmin && this.showBottomNav() && (item?.label === 'Dashboard' || item?.label === 'Home')) {
      this.superAdminAccessService.setTab(item.label === 'Dashboard' ? 'admin' : 'account');
    }
    if (item?.label !== 'Chat Rooms') return;
    const url = this.normalizeUrl(this.router.url);
    if (url === '/chat-rooms') {
      this.chatViewService.requestCollapseToList();
    }
  }

  private getActiveMenuIndex(): number {
    const url = this.normalizeUrl(this.router.url);
    return this.menuItems.findIndex((item) => {
      if (this.isSuperAdmin && this.showBottomNav() && (item.label === 'Dashboard' || item.label === 'Home')) {
        return this.isItemActive(item, false);
      }
      if (item.extraActiveRoutes?.length) {
        return item.extraActiveRoutes.some((route: string) => url === route || url.startsWith(route + '/'));
      }
      const path = item.routerLink?.[0] ?? '';
      if (!path) return false;
      return item.label === 'Home' ? url === path : (url === path || url.startsWith(path + '/'));
    });
  }
  private scrollActiveBottomNavIntoView(): void {
    const index = this.getActiveMenuIndex();
    if (index < 0) return;
    const el = this.bottomNavItems?.get(index)?.nativeElement;
    el?.scrollIntoView({ behavior: 'auto', inline: 'center', block: 'nearest' });
  }

  returnToSuperAdmin(): void {
    this.impersonationService.stopImpersonation().then(response => {
      if (response?.status) {
        window.location.href = '/home';
      }
    }).catch(error => {
      console.error('Failed to return to super admin:', error);
    });
  }

  private checkMoreMenuActive(): void {
    const url = this.normalizeUrl(this.router.url);
    this.isMoreMenuActive = this.moreMenuItems.some(item => {
      const extraActiveRoutes = (item as any).data?.extraActiveRoutes as string[] | undefined;
      if (extraActiveRoutes?.length) {
        return extraActiveRoutes.some(route => url === route || url.startsWith(route + '/'));
      }
      if (item.routerLink && Array.isArray(item.routerLink)) {
        return this.router.isActive(item.routerLink.join('/'), false);
      }
      return false;
    });
  }

  private setupSearch(): void {
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(query => {
        // Clear previous results immediately upon starting a new search
        this.searchResults = [];
        this.hasMoreResults = false;

        if (!query.trim()) {
          this.isSearching = false;
          return of({ data: [], total: 0 });
        }

        this.isSearching = true;
        return this.globalSearchService.search({
          search: query,
          type: 'all',
          limit: this.searchLimit,
          offset: 0
        });
      }),

      takeUntil(this.destroy$)
    ).subscribe({
      next: (response) => {
        this.searchResults = response.data;
        this.imageErrors = {};
        this.isSearching = false;
        this.hasMoreResults = this.searchResults.length < response.total;
      },
      error: (err) => {
        console.error('Search error', err);
        this.searchResults = [];
        this.hasMoreResults = false;
        this.isSearching = false;
      }
    });
  }


  loadMore(): void {
    if (this.isLoadingMore || !this.hasMoreResults) return;

    this.isLoadingMore = true;
    const currentQuery = this.searchQuery;
    const currentOffset = this.searchResults.length;

    this.globalSearchService.search({
      search: currentQuery,
      type: 'all',
      limit: this.searchLimit,
      offset: currentOffset
    }).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if (this.searchQuery === currentQuery) {
          this.searchResults = [...this.searchResults, ...response.data];
          this.hasMoreResults = this.searchResults.length < response.total;
          this.scrollToBottom();
        }
        this.isLoadingMore = false;
      },
      error: (err) => {
        console.error('Load more error', err);
        this.isLoadingMore = false;
      }
    });

  }


  private scrollToBottom(): void {
    setTimeout(() => {
      if (this.scrollContainer) {
        this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
      }
    }, 100);
  }


  @ViewChild('loadMoreTrigger') loadMoreTrigger!: ElementRef;

  scrollToResults(): void {
    if (this.scrollContainer && this.loadMoreTrigger) {
      const dropdownTop = this.scrollContainer.nativeElement.getBoundingClientRect().top;
      const triggerTop = this.loadMoreTrigger.nativeElement.getBoundingClientRect().top;
      const scrollOffset = triggerTop - dropdownTop + this.scrollContainer.nativeElement.scrollTop;

      this.scrollContainer.nativeElement.scrollTo({
        top: scrollOffset,
        behavior: 'smooth'
      });
    }
  }


  onSearchInput(event: Event): void {
    const query = (event.target as HTMLInputElement).value;
    this.searchQuery = query;
    if (!query.trim()) {
      this.imageErrors = {};
    }
    this.showSearchDropdown = true;
    this.showAllResultsInDropdown.set(false);
    this.searchSubject.next(query);
  }

  onImageError(result: GlobalSearchResult): void {
    const key = result.id + result.source_type;
    this.imageErrors[key] = true;
  }

  getSearchImageUrl(result: GlobalSearchResult): string {
    const pp = result.profile_picture;
    if (!pp) return result.images?.[0] || '';
    if (typeof pp === 'string') return pp;
    return pp.url || result.images?.[0] || '';
  }

  isSearchImageFlagged(result: GlobalSearchResult): boolean {
    const pp = result.profile_picture;
    const status = (pp && typeof pp === 'object' ? pp.moderation_status : null) ?? result.profile_picture_moderation_status;
    return status === 'flagged' || status === 'blocked';
  }

  hasSearchImage(result: GlobalSearchResult): boolean {
    return !!this.getSearchImageUrl(result);
  }

  onSearchFocus(): void {
    this.showSearchDropdown = true;
  }

  closeSearchDropdown(): void {
    this.showSearchDropdown = false;
  }

  seeAllResults(): void {
    if (!this.searchQuery.trim()) return;
    this.showSearchDropdown = false;
    this.router.navigate(['/global-search'], {
      queryParams: {
        q: this.searchQuery,
        type: 'all'
      }
    });
  }


  clearSearch(): void {
    this.searchQuery = '';
    this.searchResults = [];
    this.showSearchDropdown = false;
  }

  resetSearch(): void {
    this.searchQuery = '';
    this.searchResults = [];
    this.searchSubject.next('');
  }

  redirectToResult(result: GlobalSearchResult): void {
    this.showSearchDropdown = false;
    this.searchQuery = '';
    this.isSearchActive.set(false);
    setTimeout(() => this.updateVisibleItems());

    switch (result.source_type) {
      case 'user':
      case 'business':
      case 'management':
        this.router.navigate(['/contacts', result.id]);
        break;
      case 'collab':
        this.router.navigate(['/collab', result.id]);
        break;
      case 'listing':
        this.router.navigate(['/listings', result.id]);
        break;
      case 'meetup':
        this.router.navigate(['/meetups', result.id]);
        break;
      case 'meetup_user':
        this.router.navigate(['/meetup-user', result.id]);
        break;
      case 'fundraise':
        this.router.navigate(['/fundraise', result.id]);
        break;
      case 'prime':
        this.router.navigate(['/prime', result.id]);
        break;
      case 'prime_user':
        this.router.navigate(['/prime-user', result.id]);
        break;
      case 'message_group':
        this.router.navigate(['/chat-rooms']);
        break;
      case 'chat_room':
      case 'chat_rooms':
      case 'chatroom': {
        const state = { chatRoomId: String(result.id) };
        this.chatViewService.requestOpenRoom(state);
        this.router.navigate(['/chat-rooms'], { state });
        break;
      }
      case 'booking':
      case 'bookings':
      case 'general_bookings':
        this.router.navigate(['/bookings', result.id]);
        break;
      case 'reminder':
      case 'reminders':
      case 'reminder_request':
        this.router.navigate(['/reminders', result.id]);
        break;
      case 'file_center':
      case 'file_directory':
      case 'directory':
        this.router.navigate(['/file-center', result.directory_id ?? result.id, result.id]);
        break;
      default:
        console.warn('Unknown source type', result.source_type);
    }
  }


  onGetVerifiedRequest(targetUserData: any): void {
    this.verificationTargetUser.set(targetUserData ?? null);
    this.showVerificationPopup.set(true);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}